<template>
  <div>
    <div class="mt-2 mb-10">
      <h2 class="text-2xl font-semibold mb-8">Support</h2>
      <div class="mb-10">
        <div class="max-w-xl flex bg-white p-6 border shadow rounded-lg mr-10">
          <p>
            If you have any issue or just want to say hello, please contact us
            at <a class="text-blue-600">hello@meetadbox.com.</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
